var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"align-items-center",attrs:{"no-gutters":""}},[_c('h1',{staticClass:"col"},[_vm._v("Novo Arquivo")]),(!_vm.hasPeddingFiles)?_c('b-btn',{attrs:{"to":{ name: 'files_list' }}},[_vm._v(" Voltar ")]):_vm._e()],1),_c('list-files')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }